import axios from "axios";
import store from "@/store/index";
import { Notification, MessageBox } from "element-ui";
import { getToken, setToken } from "@/utils/storage";
import { message } from "@/utils/resetMessage";
import Vue from "vue";
// 定义Vue实例 调用全局显示和关闭loading方法
const vm = new Vue();

axios.defaults.baseURL = window.baseUrl;
axios.defaults.timeout = 10000;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;
axios.defaults.retry = 3; //重试次数
axios.defaults.retryDelay = 3000; //重试间隔

//对外接口
export function request({ url, params, method, timeout }) {
  if (!method) {
    method = "post";
  }
  if (!timeout) {
    timeout = 10000;
  }
  if (method === "get") {
    return get(url, params);
  } else if (method === "post") {
    return post(url, params, timeout);
  }
}

//对外接口
export function requestNew({ url, params, method, timeout, isShow }) {
  if (!method) {
    method = "post";
  }
  if (!timeout) {
    timeout = 10000;
  }
  if (!isShow) {
    isShow = "0";
  }
  if (method === "get") {
    return get(url, params);
  } else if (method === "post") {
    return postNew(url, params, timeout, isShow);
  }
}

//文件上传接口
export function requestFile({ url, formdata }) {
  let timeout = 30000;
  let isShow = "1";
  return postFile(url, formdata, timeout, isShow);
}

//封装get方法
function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, params)
      .then((res) => {
        if (res.code == constants.interfaceResult.success) {
          resolve(res.data);
        } else {
          if (getToken() && res.msg !== "") {
            message.error({
              message: res.msg,
              showClose: true,
              duration: 4000,
              offset: 100,
            });
          }
          reject(res.msg);
        }
      })
      .catch((err) => {
        reject(err.msg);
      });
  });
}

//封装post方法
function post(url, params, timeout) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, { timeout: timeout })
      .then((res) => {
        if (res.code == constants.interfaceResult.success) {
          resolve(res.data);
        } else {
          if (getToken() && res.msg !== "") {
            message.error({
              message: res.msg,
              showClose: true,
              duration: 4000,
              offset: 100,
            });
          }
          console.log("1111111111111:", JSON.stringify(res));
          reject(res.msg);
        }
      })
      .catch((err) => {
        console.log("222222222222:",JSON.stringify(err));
        reject(err);
      });
  });
}

function postNew(url, params, timeout, isShow) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, { timeout: timeout, showTop: isShow })
      .then((res) => {
        if (res.code == constants.interfaceResult.success) {
          resolve(res.data);
        } else {
          if (getToken() && res.msg !== "") {
            message.error({
              message: res.msg,
              showClose: true,
              duration: 4000,
              offset: 100,
            });
          }
          reject(res.msg);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function postFile(url, formdata, timeout, isShow) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, formdata, { timeout: timeout, showTop: isShow, fileFlag: "1" })
      .then((res) => {
        if (res.code == constants.interfaceResult.success) {
          resolve(res.data);
        } else {
          if (getToken() && res.msg !== "") {
            message.error({
              message: res.msg,
              showClose: true,
              duration: 4000,
              offset: 100,
            });
          }
          reject(res.msg);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// request拦截器
axios.interceptors.request.use(
  (config) => {
    if (config.showTop == "1") {
      vm.$showLoading();
    }
    if (getToken()) {
      config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token
    }
    if (config.fileFlag === "1") {
      config.headers["Content-Type"] = "amultipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    vm.$hideLoading();
    Promise.reject(error);
  }
);

// response 拦截器
axios.interceptors.response.use(
  (response) => {
    vm.$hideLoading();

    console.log("333333333333:",JSON.stringify(response));
    // 接收后台参数状态
    if (response.status == 200 && response.data.code == 0) {
      return response.data;
    } else {
      let res = response.data;

      //这里可以设置后台返回状态码是500或者是其他,然后重定向跳转
      if (res.code == 403 || res.code == 401) {
        setToken(null);
        window.globalRouter.push({ path: "/login" });
        message.error({
          message: res.msg,
          duration: 15000,
          offset: 100,
          showClose: true,
        });
      } else {
        if (res.code > 500) {
          message.error({
            message: "错误信息：" + res.msg + ",请截图返回给客服。",
            duration: 15000,
            offset: 100,
            showClose: true,
          });
        }
      }
      return Promise.reject(
        new Error(res.msg || (res.error && res.error.message) || "未知错误")
      );
    }
  },
  (error) => {
    vm.$hideLoading();
    var config = error.config;
    if (error.response && Object.keys(error.response).length != 0) {
      let code = error.response.status;
      if (code === 401 || code === 403) {
        localStorage.clear();
        window.globalRouter.push({ path: "/login" });
        message.error({
          message: "登录过期，请重新登录",
          duration: 5000,
          offset: 100,
          showClose: true,
        });
        return Promise.reject(error.message);
      } else if (code == 503) {
        // 创建延时器等待发送重试请求
        var backoff1 = new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, 3000);
        });
        // 返回调用AXIOS来重试请求
        return backoff1.then(() => {
          return axios(config);
        });
      } else if (code > 500) {
        message.error({
          message: "错误信息：" + error.message + ",请截图返回给客服。",
          duration: 15000,
          offset: 100,
          showClose: true,
        });
      }
    }

    message.error({
      message: "错误信息：" + error.message,
      duration: 15000,
      offset: 100,
      showClose: true,
    });
    // 设置变量即跟踪重试次数
    config.__retryCount = config.__retryCount || 0;
    config.retryDelay = 3000;
    // 检查我们是否已经超过了总重试次数
    if (config.__retryCount >= 3) {
      // 返回错误信息
      if (error.response && Object.keys(error.response).length != 0) {
        // error.response有错误信息,是接口错误,不是取消请求
        // 获取错误码,弹出提示信息,reject()
        let code = error.response.status;
        if (code == 401) {
          setToken(null);
          window.globalRouter.push({ path: "/login" });
          return Promise.reject(error.message);
        } else if (code == 403) {
          MessageBox.confirm(
            "登录状态已过期，您可以继续留在该页面，或者重新登录",
            "系统提示",
            {
              confirmButtonText: "重新登录",
              cancelButtonText: "取消",
              type: "warning",
            }
          ).then(() => {
            setToken(null);
            window.globalRouter.push({ path: "/login" });
          });
          return Promise.reject(error.message);
        } else if (code >= 500) {
          message.error({
            message: "错误信息：" + error.message + ",请截图返回给客服。",
            duration: 15000,
            offset: 100,
            showClose: true,
          });
        } else {
          message.error({
            message: error.message,
            duration: 15000,
            offset: 100,
            showClose: true,
          });
        }
      }
      return Promise.reject(error.response.data);
    } else {
      if (error.response && Object.keys(error.response).length != 0) {
      } else {
        if (
          error.message.indexOf("401") > -1 ||
          error.message.indexOf("403") > -1
        ) {
          setToken(null);
          window.globalRouter.push({ path: "/login" });
          message.error({
            message: "登录过期，请重新登录",
            duration: 5000,
            offset: 100,
            showClose: true,
          });
          return Promise.reject(error.message);
        }
      }
    }
    // 重试次数加1
    config.__retryCount++;

    // 创建延时器等待发送重试请求
    var backoff = new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, config.retryDelay || 1);
    });

    // 返回调用AXIOS来重试请求
    return backoff.then(() => {
      return axios(config);
    });
  }
);
